<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <el-table :data="list" v-loading="listLoading" style="width: 100%" @selection-change="handleChoose">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column label="服务标签" prop="Tag"></el-table-column>
      <el-table-column label="标签说明" prop="TagDescription"></el-table-column>
      <el-table-column label="排序" prop="OrderSort"></el-table-column>
      <el-table-column
        label="是否显示"
        prop="IsAnswer"
        :formatter="formatIsAnswer"
      ></el-table-column>
      <el-table-column
        label="显示Logo"
        prop="IsLogo"
        :formatter="formatLogo"
      ></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <!-- 新增 -->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="服务标签" prop="Tag">
          <el-input v-model="addForm.Tag"></el-input>
        </el-form-item>
        <el-form-item label="对应比赛" prop="MatchId">
          <el-select v-model="addForm.MatchId" placeholder="请选择">
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签说明" prop="TagDescription">
          <el-input v-model="addForm.TagDescription"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input-number v-model="addForm.OrderSort"></el-input-number>
        </el-form-item>
        <el-form-item label="是否显示" prop="IsAnswer">
          <el-switch v-model="addForm.IsAnswer"></el-switch>
        </el-form-item>
        <el-form-item label="显示Logo">
          <el-switch
            v-model="addForm.IsLogo"
            active-text="√"
            inactive-text="×"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 编辑  -->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="服务标签" prop="Tag">
          <el-input v-model="editForm.Tag"></el-input>
        </el-form-item>
        <el-form-item label="对应比赛" prop="MatchId">
          <el-select v-model="editForm.MatchId" placeholder="请选择">
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签说明" prop="TagDescription">
          <el-input v-model="editForm.TagDescription"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="OrderSort">
          <el-input-number v-model="editForm.OrderSort"></el-input-number>
        </el-form-item>
        <el-form-item label="是否显示" prop="IsAnswer">
          <el-switch v-model="editForm.IsAnswer"></el-switch>
        </el-form-item>
        <el-form-item label="显示Logo">
          <el-switch
            v-model="editForm.IsLogo"
            active-text="√"
            inactive-text="×"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>
<script>
import util from "../../../util/date";
import {
  serviceTagList,
  matchListAll,
  addServiceTag,
  deleteServiceTag,
  updateServiceTag,
  batchDeleteServiceTag,
} from "@/api/match/match";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      matchList: [],
      idList:[],
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
    this.getMatch();
  },
  methods: {
    handleBatchDelete(){
        this.$confirm("确认删除吗?", "提示", {
          type: "warning",
        }).then(() => {
           batchDeleteServiceTag({ids:this.idList}).then(res=>{
               if(res.data.success){
                   this.initPage();
                   this.$message({
                       message: "删除成功",
                       type: "success",
                   });
                   this.getList();
               }
           })     
        })
        
    },
    handleChoose(e) {
      
      this.idList = e.map((item) => item.Id);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    editSubmit() {
      updateServiceTag(this.editForm).then((res) => {
        if (util.isEmt.format(res)) {
          this.editLoading = false;
          return;
        }
        if (res.data.success) {
          this.editLoading = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.$refs["editForm"].resetFields();
          this.editFormVisible = false;
          this.initPage();
          this.getList();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    addSubmit() {
      addServiceTag(this.addForm).then((res) => {
        if (util.isEmt.format(res)) {
          this.addLoading = false;
          return;
        }
        if (res.data.success) {
          this.addLoading = false;

          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.$refs["addForm"].resetFields();
          this.addFormVisible = false;
          this.initPage();
          this.getList();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handleEdit(row) {
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
    },
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteServiceTag({
          id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    formatIsAnswer(row, column, cellVale, index) {
      return cellVale ? "是" : "否";
    },
    formatLogo(row, column, cellVale, index) {
      return cellVale ? "√" : "×";
    },
    getMatch() {
      matchListAll().then((res) => {
        this.matchList = res.data.response;
      });
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    getList() {
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
      };
      this.listLoading = true;
      serviceTagList(para)
        .then((res) => {
          this.list = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
  },
};
</script>
<style lang="css" scoped>
</style>